import React, { Component } from "react";
import {
  Text,
  View,
  Image,
  ScrollView,
  Dimensions,
  ActivityIndicator,
  Picker,
  Platform,
} from "react-native";
import {
  Flex,
  Padding,
  Margin,
  Helpers,
  Typo,
  article,
  button,
  articleItem,
  FontFamily,
  articleLists,
  ontWeight,
  Colors,
  appHeader,
  FontWeight,
} from "../../styles/appStyles";
import TouchableOpacityLink from "../touchable-opacity-link";
import ArticleItemHorizontal from "../article-item-horizontal";
import ScrollContainerView from "../scroll-container-view";
import { helpers } from "../../utils/helpers";
import PageBreak from "../page-break";
import ArticleItem from "../article-item";
import CustomImage from "../custom-image";
import getImagePath from "../../utils/image-helper";
import Cookies from "universal-cookie";
import { Mixpanel } from "../../utils/mixpanel";
import AuthenticationWrapper from "../authentication-wrapper";
import ArticleTopStories from "../article-item-vertical/index-top-stories";
import ArticleSpecificIndexStories from "../article-item-vertical/article-verticle-specific-index";

const viewMore = getImagePath("icons/view-more.png");
const cookies = new Cookies();

export class HomeLatestStory extends Component {
  constructor(props) {
    super(props);
    let webView = helpers.isWeb();
    const { isAuthenticated, fetchToken } = this.props.auth;
    this.TodayStoryData = [];
    let token = webView
      ? process.browser
        ? isAuthenticated
          ? fetchToken
          : false
        : this.props.token
      : this.props.user?.userData?.data?.token;

    this.state = {
      showToken: !helpers.isWeb() || process.browser ? true : false,
      selectedTab: "Today",
      TodayStoryData: [],
      lastWeekData: [],
    };
  }

  componentDidMount = () => {
    const { data } = this.props;
    const today = new Date().toISOString();
    let current_time_stamp = Date.parse(today);

    // Filtering todays date record only from Total array of data
    const filterByExpiration = data.filter(
      ({ published_date }) =>
        published_date.split(" ")[0] == today.split("T")[0]
    );

    data &&
      data.map((item, index) => {
        let published_date = new Date(item.published_date.replace(/-/g, "/"));
        var next_day = new Date(
          new Date(published_date).setDate(published_date.getDate() + 1)
        );
        next_day.setHours(7, 56, 0);
        let nextday_time_stamp = Date.parse(next_day);

        // Checking if todays record available. show the data
        if (
          filterByExpiration.length &&
          item.published_date.split(" ")[0] == today.split("T")[0]
        ) {
          this.TodayStoryData.push(item);
        }

        // Checking, if todays record not available, show the previous record until 7:55AM
        if (
          filterByExpiration.length === 0 &&
          current_time_stamp < nextday_time_stamp
        ) {
          this.TodayStoryData.push(item);
        }
      });

    let lastWeekData;
    // If story is not published after 7.55AM
    if (this.TodayStoryData.length === 0) {
      this.setState({ selectedTab: "Most Recent" });
      lastWeekData = data;
    } else {
      // Filter the last week records to display in the Last Week tab
      lastWeekData = data.filter((el) => {
        return this.TodayStoryData.some((f) => {
          return (
            f.published_date.split(" ")[0] !== el.published_date.split(" ")[0]
          );
        });
      });
    }

    this.setState({
      TodayStoryData: this.TodayStoryData,
      lastWeekData: lastWeekData,
    });
  };

  viewMoreArticles = () => {
    const { viewAllArticles } = this.props;
    viewAllArticles();
  };

  viewArticle = (catSlug, slug, postData) => {
    const { viewArticle } = this.props;
    viewArticle(catSlug, slug, postData);
  };

  viewAuthor = (slug) => {
    const { viewAuthor } = this.props;
    viewAuthor(slug);
  };
  viewCategory = (slug) => {
    const { viewCategory } = this.props;
    viewCategory(slug);
  };

  handleClick = (title, data, index) => {
    try {
      if (this.props.trackStoryClick) {
        this.props.trackStoryClick(title, data, index);
      }
    } catch (error) {
      console.log("check mix panel track error ==>", error);
    }
  };

  trackViewAll = () => {
    try {
      Mixpanel.track("click_view_more_latest");
    } catch (error) {}
  };

  trackCateoryClick = (item) => {
    // try {
    //     Mixpanel.track('category', {category_slug: item.category.slug, source_section_type: 'home_latest_stories', section_value: { title : item.name, slug: item.slug } });
    // }
    // catch(error) {
    //     console.log("mix panel error =>", error);
    // }
  };

  setTab = (slug) => {
    this.setState({ selectedTab: slug });
  };

  render() {
    const { data, darkMode } = this.props;
    const { selectedTab, TodayStoryData, lastWeekData } = this.state;
    let btnClick, btnClickCategory;
    let webView = helpers.isWeb();
    let tab_num_arr = [];

    // Creating tabs
    if (TodayStoryData.length) {
      tab_num_arr = [
        { id: 1, name: "Today" },
        { id: 2, name: "This Week" },
      ];
    } else {
      tab_num_arr = [{ id: 1, name: "Most Recent" }];
    }
    // END Creating tabs

    if (helpers.isWeb()) {
      btnClick = {
        to: "/all-stories",
      };
    } else {
      btnClick = {
        onPress: () => this.viewMoreArticles(),
      };
    }
    let viewAllBtn;
    if (helpers.isWeb()) {
      viewAllBtn = {
        to:
          selectedTab === "This Week" || selectedTab === "Most Recent"
            ? "/last-week"
            : "/all-stories",
      };
    } else {
      viewAllBtn = {
        onPress: () =>
          this.props.navigateApp(
            selectedTab === "This Week" || selectedTab === "Most Recent"
              ? "/last-week"
              : "/all-stories"
          ),
      };
    }

    return (
      <View
        style={[
          helpers.isDesktop() && Padding.ph_2,
          Helpers.conatinerWeb,
          helpers.isDesktop() && Helpers.conatinerWebFull,
          helpers.isDesktop() && { marginTop: 40 },
          !helpers.isDesktop() && { paddingBottom: 0 },
          darkMode && { backgroundColor: Colors.darkBlackColorBg },
        ]}
      >
        <View
          style={[
            article.headerWrapper,
            helpers.isDesktop() && Margin.mb_3,
            !helpers.isDesktop() && { paddingTop: 30 },
          ]}
        >
          {!helpers.isDesktop() && (
            <View style={[appHeader.trendingWrapper, { alignSelf: "center" }]}>
              <Text
                style={[
                  { fontFamily: FontFamily.abrilFatface },
                  {
                    fontSize: 34,
                    color: !helpers.isDesktop() ? "#051462" : "#000",
                    fontWeight: "400",
                  },
                  !helpers.isDesktop() && { lineHeight: 51, paddingBottom: 12 },
                  { width: helpers.isWeb() ? "fit-content" : "100%" },
                  darkMode && { color: "rgba(255,255,255,0.87)" },
                ]}
              >
                Latest Stories
              </Text>
            </View>
          )}
          <View
            style={[
              { flexDirection: "row" },
              !helpers.isDesktop() && { alignSelf: "center" },
            ]}
          >
            {helpers.isDesktop() && (
              <View style={[Flex.alignStart]}>
                <View style={[appHeader.trendingWrapper]}>
                  <Text
                    style={[
                      { fontFamily: FontFamily.abrilFatface },
                      {
                        fontSize: helpers.isDesktop() ? 30 : 20,
                        color: "#000",
                        fontWeight: "400",
                      },
                      { width: helpers.isWeb() ? "fit-content" : "100%" },
                      darkMode && { color: "rgba(255,255,255,0.87)" },
                    ]}
                  >
                    Latest Stories
                  </Text>
                </View>
              </View>
            )}

            {/* Create tab for today and last week */}
            {tab_num_arr.map((d, i) => {
              return (
                <View
                  style={[appHeader.trendingWrapper]}
                  key={`latestNews_${d.id}`}
                >
                  <TouchableOpacityLink
                    //   {...viewAllBtnProps}
                    handleClick={() => {
                      this.setTab(d.name);
                    }}
                  >
                    <Text
                      style={[
                        { fontFamily: FontFamily.abrilFatface },
                        {
                          fontSize: helpers.isDesktop() ? 20 : 20,
                          color: "#000",
                          fontWeight: "400",
                        },
                        {
                          color: selectedTab == d.name ? "#6C7AF6" : "#000",
                          borderBottomWidth: selectedTab == d.name ? 2 : 0,
                          borderBottomColor:
                            selectedTab == d.name ? "#6C7AF6" : "#000",
                        },
                        { width: helpers.isWeb() ? "fit-content" : "100%" },
                        darkMode && { color: "rgba(255,255,255,0.87)" },
                      ]}
                    >
                      {d.id === 2 ? "Last Week" : d.name}
                    </Text>
                  </TouchableOpacityLink>
                </View>
              );
            })}

            {helpers.isDesktop() && (
              <View style={[appHeader.trendingWrapper, { marginLeft: "auto" }]}>
                <TouchableOpacityLink {...viewAllBtn}>
                  <Text
                    style={[
                      Helpers.textUppercase,
                      {
                        color: "#907CFF",
                        fontSize: 18,
                        fontFamily: FontFamily.medium,
                        fontWeight: FontWeight.semiBold,
                        whiteSpace: "nowrap",
                        borderWidth: 1,
                        borderColor: "#907CFF",
                        paddingHorizontal: 30,
                        paddingVertical: 10,
                      },
                    ]}
                  >
                    {selectedTab === "This Week" ||
                    selectedTab === "Most Recent"
                      ? "VIEW LAST WEEK’S STORIES"
                      : "VIEW ALL STORIES"}
                  </Text>
                </TouchableOpacityLink>
              </View>
            )}
          </View>
        </View>

        <View
          style={[
            Margin.mt_1,
            Margin.mb_4,
            helpers.isDesktop() && Margin.mb_7,
            !helpers.isDesktop() && Padding.ph_2,
            { paddingLeft: 0, paddingRight: 0 },
          ]}
        >
          {selectedTab === "Today" && (
            <ArticleSpecificIndexStories
              data={TodayStoryData}
              darkMode={darkMode}
            />
          )}

          {helpers.isDesktop() ? (
            <View style={[Flex.row, Flex.FlexWrap]}>
              {
                <>
                  {lastWeekData &&
                    lastWeekData.slice(0, 5).map((item, index) => {
                      if (
                        selectedTab == "This Week" ||
                        selectedTab == "Most Recent"
                      ) {
                        if (helpers.isWeb()) {
                          btnClickCategory = {
                            to: "/category/" + item.category.slug,
                          };
                        } else {
                          btnClickCategory = {
                            onPress: () =>
                              this.viewCategory(item.category.slug),
                          };
                        }
                        return (
                          <View style={[Flex.row, Flex.FlexWrap]}>
                            <ArticleTopStories
                              writers={false}
                              home={true}
                              latestStories={true}
                              all={index === 0 ? true : false}
                              viewArticle={(catSlug, slug, postData) =>
                                this.viewArticle(catSlug, slug, postData)
                              }
                              viewAuthor={(slug) => this.viewAuthor(slug)}
                              data={item}
                              single={index == 0 ? true : false}
                              elmsecond={index == 1 ? true : false}
                              exclusiveHome={true}
                              handleClick={(title) => {
                                this.handleClick(title, item, index);
                              }}
                              hideDate={true}
                              darkMode={darkMode}
                            />
                          </View>
                        );
                      }
                    })}
                </>
              }
            </View>
          ) : (
            <View
              style={[Margin.mb_4, !process.browser && { overflow: "hidden" }]}
            >
              {lastWeekData &&
                lastWeekData.slice(0, 5).map((item, index) => {
                  if (
                    selectedTab == "This Week" ||
                    selectedTab == "Most Recent"
                  ) {
                    return (
                      <View style={{ marginTop: 20, marginBottom: 20 }}>
                        <TouchableOpacityLink
                          {...btnClickCategory}
                          handleClick={() => this.trackCateoryClick(item)}
                        >
                          <View>
                            <Text
                              style={[
                                articleLists.badge,
                                {
                                  width: 150,
                                  marginTop: !helpers.isDesktop() ? "-18px" : 0,
                                  marginBottom: 15,
                                  textAlign: "left",
                                  fontFamily: FontFamily.regular,
                                  color: "#907cff",
                                  fontSize: 13,
                                  lineHeight: 16,
                                  letterSpacing: 0.5,
                                },
                                !helpers.isDesktop() && { paddingLeft: 20 },
                                !helpers.isWeb() && {
                                  fontFamily: FontFamily.semiBold,
                                },
                              ]}
                            >
                              {item.category.name}
                            </Text>
                          </View>
                        </TouchableOpacityLink>
                        <View
                          style={{
                            marginTop: !helpers.isDesktop() ? "-32px" : 0,
                          }}
                        >
                          <ArticleItemHorizontal
                            viewArticle={(catSlug, slug, postData) =>
                              this.viewArticle(catSlug, slug, postData)
                            }
                            viewAuthor={(slug) => this.viewAuthor(slug)}
                            data={item}
                            single={index == 0 ? true : false}
                            exclusiveHome={true}
                            handleClick={(title) => {
                              this.handleClick(title, item, index);
                            }}
                            hideDate={true}
                            darkMode={darkMode}
                          />
                        </View>
                      </View>
                    );
                  }
                })}
              {/* <TouchableOpacityLink
                            {...btnClick}  handleClick={(title) => {this.trackViewAll()}}
                        >
                            <View style={[Flex.column, Flex.alignCenter,{width: 155, position:'absolute', top: 100, marginLeft: -15}]}>
                                <CustomImage
                                    source={viewMore}
                                    require={true}
                                    style={{ width: 36, height: 36, margin: 'auto' }}
                                    webStyle={{ width: 36, height: 36, margin: 'auto'}}
                                />
                                <Text style={[button.secondaryOutlineText, Margin.mr_0, {fontWeight: '500'}]}>View all articles</Text>
                            </View>
                        </TouchableOpacityLink> */}
            </View>
          )}

          {!helpers.isDesktop() && (
            <View style={[appHeader.trendingWrapper, { alignSelf: "center" }]}>
              <TouchableOpacityLink {...viewAllBtn}>
                <Text
                  style={[
                    Helpers.textUppercase,
                    {
                      color: "#907CFF",
                      fontSize: 18,
                      fontFamily: FontFamily.medium,
                      fontWeight: FontWeight.semiBold,
                      whiteSpace: "nowrap",
                      borderWidth: 1,
                      borderColor: "#907CFF",
                      paddingHorizontal: 20,
                      paddingVertical: 10,
                    },
                  ]}
                >
                  {selectedTab === "This Week" || selectedTab === "Most Recent"
                    ? "VIEW LAST WEEK’S STORIES"
                    : "VIEW ALL STORIES"}
                </Text>
              </TouchableOpacityLink>
            </View>
          )}
        </View>
      </View>
    );
  }
}

export default AuthenticationWrapper(HomeLatestStory);
